import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { getMe } from '../api/Api';

const AuthContext = createContext({ user: null, loading: true, refresh: () => {} });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = async (signal) => {
    try {
      const me = await getMe(signal);
      if (me && !me.error) {
        setUser(me);
      } else {
        setUser(null);
      }
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    fetchMe(controller.signal);
    return () => controller.abort();
  }, []);

  // Optionally refresh when window regains focus
  useEffect(() => {
 //   const onFocus = () => fetchMe();
   // window.addEventListener('focus', onFocus);
   // return () => window.removeEventListener('focus', onFocus);
  }, []);

  const value = useMemo(() => ({ user, loading, refresh: fetchMe }), [user, loading]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
